import request from '@/utils/request'

/**
 * 项目相关接口
 */

//获取当前用户项目列表
export const getProjectList = (data) => {
    return request.get('/api/agent/project/list', data)
}
//分页获取项目列表
export const getProjectListByPage = (data) => {
    return request.post('/api/agent/project/getProjectList', data)
}

//初始化项目数据
export const initProjectData = () => {
    return request.get('/api/agent/project/init')
}
//项目详情接口
export const getProjectDetail = (data) => {
    return request.get('/api/agent/project/detail', data)
}
//删除项目接口
export const deleteProject = (projectCode) => {
    return request.post('/api/agent/project/delete?projectCode=' +  projectCode)
}
// 进入流程
export const enterEvaluation = (data) => {
    return request.get('/api/agent/project/enterEvaluation', data)
}

// 保存-提交
export const addProject = (data) => {
    return request.post('/api/agent/project/add', data)
}

// 投标人-获取开标信息
export const getBidOpeningInfo = (sectionCode) => {
    return request.get('/api/opening/bid/info?sectionCode='+sectionCode)
}

/**
 * 标段相关接口
 */

//获取项目下标段列表
export const getBidSectionList = (data) => {
    return request.get('/api/agent/bidSection/list', data)
}
//初始化标段数据
export const initBidSectionData = () => {
    return request.get('/api/agent/bidSection/init')
}
//获取标段详情
export const getBidSectionDetail = (data) => {
    return request.get('/api/agent/bidSection/detail', data)
}
//删除标段
export const deleteBidSection = (data) => {
    return request.post('/api/agent/bidSection/delete?bidSectionCode=' + data.bidSectionCode)
}
//保存标段
export const addBidSection = (data) => {
    return request.post('/api/agent/bidSection/add', data)
}
/**
 * 标书文件相关接口
 */

//获取项目下文件列表
export const getBidInvitationDocumentsList = (data) => {
    return request.get('/api/agent/bidInvitationDocuments/wj/list', data)
}
//初始化文件数据
export const initBidInvitationDocumentsData = (data) => {
    return request.get('/api/agent/bidInvitationDocuments/init', data)
}
//获取文件详情
export const getBidInvitationDocumentsDetail = (data) => {
    return request.get('/api/agent/bidInvitationDocuments/detail', data)
}
//删除
export const deleteBidInvitationDocuments = (data) => {
    return request.post('/api/agent/bidInvitationDocuments/delete?bidInvitationDocumentsCode=' + data.bidInvitationDocumentsCode)
}
//保存-提交
export const addBidInvitationDocuments = (data) => {
    return request.post('/api/agent/bidInvitationDocuments/add', data)
}
//保存-提交澄清-补遗 文件
export const addBidInvitationDocumentsClarification = (data) => {
    return request.post('/api/agent/bidInvitationDocuments/clarification/add', data)
}
// 单独更新开标一览表和目录（开标时间前可修改）
export const updateBidOpeningListAndCatalogue = (data) => {
    return request.post('/api/agent/bidInvitationDocuments/updateBidOpeningListAndCatalogue', data)
}

/**
 * 招标公告相关接口
 */
// 获取项目下公告列表
export const getTenderNoticeList = (data) => {
    return request.get('/api/agent/tenderNotice/list', data)
}
// 初始化公告数据
export const initTenderNoticeData = (data) => {
    return request.get('/api/agent/tenderNotice/init', data)
}
// 获取公告详情
export const getTenderNoticeDetail = (data) => {
    return request.get('/api/agent/tenderNotice/detail', data)
}
// 删除
export const deleteTenderNotice = (data) => {
    return request.post('/api/agent/tenderNotice/delete?tenderNoticeCode=' + data.tenderNoticeCode)
}
// 保存-提交
export const addTenderNotice = (data) => {
    return request.post('/api/agent/tenderNotice/add', data)
}

/**
 * 招标公告审核相关接口
 */
export const getTenderNoticeAuditList = (data) => {
    return request.get('/api/agent/audit/tenderNotice/list', data)
}
// 招标公告审核详情
export const getTenderNoticeDetailForAudit = (data) => {
    return request.get('/api/agent/audit/tenderNotice/detail', data)
}
// 招标公告审核
export const checkTenderNotice = (data) => {
    return request.post('/api/agent/audit/tenderNotice/check', data)
}
/**
 * 候选人公示审核
 */

//列表
export const getWinCandidateBulletinList = (data) => {
    return request.get('/api/agent/audit/winCandidateBulletin/list', data)
}
//详情
export const getWinCandidateBulletinDetail = (data) => {
    return request.get('/api/agent/audit/winCandidateBulletin/detail?winCandidateBulletinCode='+ data.winCandidateBulletinCode)
}
//审核
export const getWinCandidateBulletinCheck = (data) => {
    return request.post('/api/agent/audit/winCandidateBulletin/check', data)
}

/**
 * 开标大厅列表接口
 */
// 添加开标记录
export const addOpeningNote = (data) => {
    return request.post('/api/opening/add/note', data)
}
// 开标大厅详情接口
export const getOpeningDetail = (data) => {
    return request.get('/api/opening/detail', data)
}

//是否具备进入开标大厅条件
export const getOpeningIsMeet =(sectionCode)=>{
     return request.get('/api/opening/is/meet?sectionCode=' + sectionCode)
}
// 招标-开标大厅列表
export const getOpeningList =(projectCode)=>{
     return request.get('/api/opening/agent/list?projectCode=' + projectCode)
}

// 投标人-开标大厅列表接口
export const getOpeningListForBidder =(data)=>{
    // 如果 envelopeCode 不为空，则添加 envelopeCode 参数
    if(data.envelopeCode){
        return request.get('/api/opening/bid/list?sectionCode='+data.sectionCode + '&envelopeCode=' + data.envelopeCode)
    }else{
        return request.get('/api/opening/bid/list?sectionCode='+data.sectionCode)
    }
}

// 获取当前时间
export const getOpeningNow =(sectionCode)=>{
     return request.get('/api/opening/now?sectionCode=' + sectionCode)
}
// 开标大厅创建记录接口
export const addOpeningRecord =(data)=>{
     return request.get('/api/opening/record', data)
}
//开标大厅切换列表
export const getOpeningSwitchList =(projectCode)=>{
     return request.get('/api/opening/switch?project=' + projectCode)
}

// 开标大厅解密
export const decryptOpening = (data) => {
    return request.post('/api/opening/decrypt', data)
}
// 开标大厅开启开标保障
export const startBidGuarantee = (bidOpeningGuid) => {
    return request.get('/api/opening/agent/guarantee?bidOpeningGuid=' +bidOpeningGuid)
}
// 公布内容
export const publish = (bidOpeningGuid) => {
    return request.get('/api/opening/agent/publish?bidOpeningGuid='+bidOpeningGuid)
}
//开标记录
export const getOpeningRecord = (data) => {
    return request.post('/api/opening/add/note', data)
}
// 获取开标记录接口
export const getOpeningRecordDetail = (sectionCode,envelopeCode) => {
    if(envelopeCode=='' || envelopeCode==null || envelopeCode==undefined){
        return request.get('/api/opening/get/note?sectionCode=' + sectionCode)
    }else{
        return request.get('/api/opening/get/note?sectionCode=' + sectionCode + '&envelopeCode=' + envelopeCode)
    }
}

//开标大厅解密信息
export const getOpeningDecryptInfo = (sectionCode) => {
  return request.get('/api/opening/decrypt/info?sectionCode=' + sectionCode)
}

/**
 * 专家相关接口
 */
// 分页获取代理专家列表
export const getExpertList = (data) => {
    return request.post('/api/expert/listPage', data)
}
// 删除专家信息
export const deleteExpert = (expertId) => {
    return request.get('/api/expert/del?expertId=' + expertId)
}
//保存专家信息
export const saveExpert = (data) => {
    return request.post('/api/expert/save', data)
}
//启用-停止
export const enableExpert = (expertId) => {
    return request.get('/api/expert/enable?expertId=' + expertId)
}

/**
 * 报名资料审核相关接口
 */
// 获取报名资料列表
export const getBidRegistrationList = (data) => {
    return request.get('/api/agent/audit/bidRegistration/list?projectCode=' + data.projectCode+"&status="+data.status+"&bidderName="+data.bidderName+"&bidSectionName="+data.bidSectionName+"&pageNum="+data.pageNum+"&pageSize="+data.pageSize)
}
//投标报名详情
export const getBidRegistrationDetail = (registrationId) => {
    return request.get('/api/agent/audit/bidRegistration/detail?registrationId=' + registrationId)
}
//投标报名审核
export const checkBidRegistration = (data) => {
    return request.post('/api/agent/audit/bidRegistration/check', data)
}
//评委组长-获取改价信息
export const getOfferList = (sectionCode) => {
    return request.get('/api/evaluation/offer?sectionCode='+sectionCode)
}
//评委组长-改价
export const getAdjust = (data) => {
    return request.post('/api/evaluation/adjust',data)
}
// 评委组长-二次报价废除
export const invalidOffer = (sectionCode) => {
    return request.get('/api/evaluation/offer/invalid?sectionCode='+sectionCode)
}
// 异常行为列表
export const getAnomalousList = (sectionCode) => {
    return request.get('/api/common/anomalous?sectionCode='+sectionCode)
}
//澄清-补遗列表
export const getClarificationList = (data) => {
    return request.post('/api/evaluation/agent/list',data)
}

// 澄清列表
export const getClarificationListForCq = (projectCode) => {
    return request.get('/api/agent/bidInvitationDocuments/cq/list?projectCode='+projectCode)
}
//初始化澄清-补遗 文件数据
export const initClarificationData = (projectCode) => {
    return request.get('/api/agent/bidInvitationDocuments/clarification/init?projectCode='+projectCode)
}
//获取澄清-补遗 文件详情
export const getClarificationDetail = (bidInvitationDocumentsCode) => {
    return request.get('/api/agent/bidInvitationDocuments/clarification/detail?bidInvitationDocumentsCode='+bidInvitationDocumentsCode)
}
//获取招标人列表
export const getTenderList = (params) => {
    return request.get('/api/agent/project/getTenderPage', params)
}
//删除招标人
export const delTender = (tenderId) => {
    return request.get('/api/agent/project/delTender?tenderId='+tenderId)
}
//添加招标人
export const saveTender = (data) => {
    return request.post('/api/agent/project/saveTender', data)
}
// 投标人签字
export const signNot =(sectionCode)=>{
      return request.get('/api/opening/note/sign?sectionCode='+sectionCode )
}
//查询投标人是否签字
export const getSignNot =(sectionCode)=>{
      return request.get('/api/opening/note/sign/status?sectionCode='+sectionCode )
}

//招标 - 开标保障一键公布
export const publishAll = (sectionCode, envelope) => {
    if(envelope){
        return request.get('/api/opening/agent/publish/all?sectionCode='+sectionCode + '&envelope=' + envelope)
    }else{
    return request.get('/api/opening/agent/publish/all?sectionCode='+sectionCode )
}
}

//导出回避名单
export const exportAvoidList = (sectionCode) => {
        return request.get('/api/agent/additional/process/avoid/export?sectionCode='+sectionCode, {
            responseType: 'blob'
        })
}
//计算报价得分标段列表
export const getQuoteSectionList = (projectCode) => {
    return request.get('/api/agent/additional/process/section/list?projectCode='+projectCode)
}

// 获取报价详情
export const getQuoteDetail = (data) => {
    return request.post('/api/agent/additional/process/quote/detail', data)
}

//计算报价得分单位列表
export const getQuoteUnitList = (data) => {
    return request.post('/api/agent/additional/process/quote/list', data)
}

//异常行为导出 - 导出串标分析结果
export const exportAnomalousAnalysis = (sectionCode) => {
    return request.get('/api/common/anomalous/export?sectionCode='+sectionCode, {
        responseType: 'blob'
    })
}

// 创建招标项目计划
export const addBuildPlan = (data) => {
    return request.post('/api/build/plan/add', data)
}

// 招标项目计划列表
export const getBuildPlanList = (data) => {
    return request.post('/api/build/plan/list', data)
}

// 建设工程-调查问卷列表
export const getBuildSurveyList = (data) => {
    return request.post('/api/build/survey/list', data)
}

// 建设工程-添加调查问卷
export const addBuildSurvey = (data) => {
    return request.post('/api/build/survey/add', data)
}

// 一键归档
export const onclickArchiving = (projectCode) => {
    return request.get('/api/agent/additional/process/onclick?projectCode='+projectCode)
}

/**
 * 采购方案相关接口
 */
// 获取采购方案分页列表
export const getPurchaseSchemePage = (params) => {
    return request.get('/api/agent/project/getPurchaseSchemePage', params)
}
//获取招标文件下载记录
export const getDownloadRecord = (params) => {
    return request.get('/api/agent/bidInvitationDocuments/getDownloadRecord', params)
}
